/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { Report } from '../../models/dashboard/report';

export enum ActionTypes {
  Update = '[Dashboard] Update report',
  Receive = '[Dashboard] Receive report',
  Error = '[Dashboard] Error'
}

export class Update implements Action {
  readonly type = ActionTypes.Update;
}

export class Receive implements Action {
  readonly type = ActionTypes.Receive;

  constructor(public payload: { report: Report; errorMessage: any }) {}
}

export class Error implements Action {
  readonly type = ActionTypes.Error;

  constructor(public payload: any) {}
}

export type ActionList = Update | Receive | Error;
